export default __webpack_public_path__ + "static/media/info.801a8f81.svg";